import React from 'react';
import PropTypes from 'prop-types';
import Tippy from '@tippyjs/react';
import { CloseButtonTooltip } from './ReactCloseButtonTooltip.component';
import { ReactTooltipContent } from './ReactTooltipContent.component';

import './thd-react-tooltip.style.scss';

const ReactTooltip = ({
  boundary,
  children,
  className,
  closeButton,
  content,
  distance,
  flip,
  interactive,
  maxWidth,
  onShow,
  placement,
  showClose,
  visible
}) => {
  return closeButton ? (
    <CloseButtonTooltip
      boundary={boundary}
      className={className}
      content={content}
      distance={distance}
      flip={flip}
      maxWidth={maxWidth}
      onShow={onShow}
      placement={placement}
      showClose={showClose}
      visible={visible}
    >
      {children}
    </CloseButtonTooltip>
  ) : (
    <Tippy
      appendTo={() => document.body}
      arrow
      className="thd-tooltip"
      content={<ReactTooltipContent className={className}>{content}</ReactTooltipContent>}
      interactive={interactive}
      maxWidth={maxWidth}
      offset={[0, distance]}
      onShow={onShow}
      placement={placement}
      popperOptions={{
        strategy: 'fixed',
        modifiers: [
          {
            name: 'flip',
            options: {
              fallbackPlacements: ['bottom']
            }
          },
          {
            name: 'preventOverflow',
            options: {
              // equivalent to boundary: 'window' in v1, usually NOT necessary in v2
              rootBoundary: 'document',
            },
          }, { name: 'flip', enabled: flip }]
      }}
    >
      {children}
    </Tippy>
  );
};

ReactTooltip.propTypes = {
  boundary: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  closeButton: PropTypes.bool,
  content: PropTypes.node.isRequired,
  distance: PropTypes.number,
  flip: PropTypes.bool,
  interactive: PropTypes.bool,
  maxWidth: PropTypes.number,
  placement: PropTypes.string,
  showClose: PropTypes.bool,
  visible: PropTypes.bool,
  onShow: PropTypes.func
};

ReactTooltip.defaultProps = {
  boundary: 'window',
  className: '',
  closeButton: false,
  distance: 25,
  flip: true,
  interactive: false,
  maxWidth: 500,
  onShow: () => {},
  placement: 'top',
  showClose: true,
  visible: false
};

export { ReactTooltip };
